var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon8(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.5361 9.8192L45.5361 39.2835L41.9647 42.8549L41.9647 7.14062L45.5361 9.8192Z",
    fill: "#FF8165"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.107 33.9275C23.8213 31.1105 21.4744 28.8957 18.5152 28.6432C17.4948 28.546 16.4539 28.546 15.4131 28.6432C12.4539 28.9152 10.107 31.1105 9.82129 33.9275",
    stroke: "#A020FF",
    strokeWidth: 1.78571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.417 43.75H14.5837C6.25033 43.75 4.16699 41.6667 4.16699 33.3333V16.6667C4.16699 8.33333 6.25033 6.25 14.5837 6.25H35.417C43.7503 6.25 45.8337 8.33333 45.8337 16.6667V33.3333C45.8337 41.6667 43.7503 43.75 35.417 43.75Z",
    stroke: "#081E54",
    strokeWidth: 1.78571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.167 16.6641H39.5837",
    stroke: "#081E54",
    strokeWidth: 1.78571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.25 25H39.5833",
    stroke: "#081E54",
    strokeWidth: 1.78571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.417 33.3359H39.5837",
    stroke: "#081E54",
    strokeWidth: 1.78571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7083 23.526C19.7909 23.526 21.4792 21.8378 21.4792 19.7552C21.4792 17.6726 19.7909 15.9844 17.7083 15.9844C15.6258 15.9844 13.9375 17.6726 13.9375 19.7552C13.9375 21.8378 15.6258 23.526 17.7083 23.526Z",
    fill: "#B7CCFF",
    stroke: "#081E54",
    strokeWidth: 1.78571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0003 34.026C24.7087 31.0052 22.3128 28.6302 19.292 28.3594C18.2503 28.2552 17.1878 28.2552 16.1253 28.3594C13.1045 28.651 10.7087 31.0052 10.417 34.026",
    stroke: "#081E54",
    strokeWidth: 1.78571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon8);
export default __webpack_public_path__ + "static/media/icon-8.4eb359e7750f825de167129a8eae8a9c.svg";
export { ForwardRef as ReactComponent };